export enum PEOPLE_COLUMNS_ORDERED {
  // propiedades básicas
  ID = 'id',
  CUSTOMER_ID = 'customer_id',
  EMAIL = 'email', // esto también podría ser un tag
  // propiedades del dispositivo
  DEVICE_ID = 'device_id',
  DEVICE = 'device',
  DEVICE_ID_TYPE = 'device_id_type',
  OS = 'os',
  OS_VERSION = 'os_version',
  IP = 'ip',
  CARRIER = 'carrier',
  ACCEPT_LANGUAGE = 'accept_language',
  CONNECTION_TYPE = 'connection_type',
  APP_VERSION = 'app_version',
  EMMA_BUILD = 'emma_build',
  // propiedades del usuario
  INSTALL_AT = 'install_at',
  UPDATED_AT = 'updated_at',
  REGISTERED_AT = 'registered_at',
  FIRST_LOGIN = 'first_login',
  LAST_LOGIN = 'last_login',
  LOYAL_USER_AT = 'loyal_user_at',
  LOYAL_BUYER_AT = 'loyal_buyer_at',
  LAST_SESSION_AT = 'last_session_at',
  CONVERSIONS = 'conversions',
  LAST_CONVERSION_AT = 'last_conversion_at',
  FIRST_CONVERSION_AT = 'first_conversion_at',
  SECONDS_TO_FIRST_CONVERSION = 'seconds_to_first_conversion',
  // geolocalización
  LATITUDE = 'latitude',
  LONGITUDE = 'longitude',
  COUNTRY = 'country',
  STATE = 'state',
  CITY = 'city',
  // otras propiedades
  INACTIVE = 'inactive',
  REFERRER_ID = 'referrer_id',
  FROM_CAMPAIGN = 'from_campaign',
  FROM_SOURCE = 'from_source',
}
